"use client";

import { c as _c } from "react/compiler-runtime";
import { Modal } from "@opensea/ui-kit";
import { useShallow } from "zustand/react/shallow";
import { useKeybindModalStore } from "@/stores/use-keybind-modal-store";
import { KeyboardShortcutsModalLayout } from "./KeyboardShortcutsModalLayout";
import { useKeyboardShortcuts } from "./useKeyboardShortcuts";
export function KeyboardShortcutsModal() {
  const $ = _c(4);
  useKeyboardShortcuts();
  const {
    modalOpen,
    setModalOpen
  } = useKeybindModalStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <KeyboardShortcutsModalLayout />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== modalOpen || $[2] !== setModalOpen) {
    t1 = <Modal content={t0} onOpenChange={setModalOpen} open={modalOpen} />;
    $[1] = modalOpen;
    $[2] = setModalOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(state) {
  return {
    modalOpen: state.modalOpen,
    setModalOpen: state.setModalOpen
  };
}